import { create } from 'zustand';

const useDataStore = create((set) => {
  return {
    upsert: (item) => {
      const { _id, schema: schemaUri } = item;
      const schemas = useDataStore.getState().schemas;
      const schema = Object.values(schemas).find((s) => s.$id === schemaUri);

      if (!schema) {
        throw new Error('Schema could not be found');
      }
      if (!_id) {
        throw new Error('Item ID is required to upsert an item');
      }

      set((state) => {
        return {
          ...state,
          [schema.collection]: {
            ...state[schema.collection],
            [item._id]: {
              ...state[schema.collection]?.[item._id],
              ...item,
              version: state[schema.collection]?.[item._id]?.version + 1,
            },
          },
        };
      });
    },
    remove: (_id, schemaUri) => {
      const schemas = useDataStore.getState().schemas;
      console.log(schemas, schemaUri);
      const schema = Object.values(schemas).find(
        (s) => s.$id === schemaUri || s.name === schemaUri,
      );

      if (!schema) {
        throw new Error('Schema could not be found');
      }
      if (!_id) {
        throw new Error('Item ID is required to remove an item');
      }
      set((state) => {
        const newState = { ...state };
        if (newState[schema.collection]) {
          delete newState[schema.collection][_id];
        }
        return newState;
      });
    },
    resetCollection: (collectionName) => {
      set((state) => ({
        ...state,
        [collectionName]: {},
      }));
    },
    setSchemas: (schemas) => {
      set((state) => ({ ...state, schemas }));
    },
  };
});

export default useDataStore;
